import { editorsPickSliderInit } from "./functions";

/*
 * Window Events
 */
$(window).on("load", function () {
  editorsPickSliderInit();
});
